import { faEnvelope, faUserTag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';

const PartnerAccount = ({ accountId, fullName, email, role="" }) => (
    <Link
        to={`/admin/accounts/${accountId}`}
        className="text-dark text-decoration-none w-25 p-1 pop-hover-xs">
        <Card>
            <CardBody>
                <div>{fullName}</div>
                <div className="op-5">
                    <FontAwesomeIcon icon={faEnvelope} />
                    &emsp;
                    {email}
                </div>
                <div className="op-5">
                    <FontAwesomeIcon icon={faUserTag} />
                    &emsp;
                    {role.replace(/([a-z])([A-Z])/g, '$1 $2')}
                </div>
            </CardBody>
        </Card>
    </Link>
);

export default PartnerAccount;
